import React from 'react';

import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from 'reactstrap';

import {gt} from 'app/utils/i18n';
type Props = {
  className?: string;
  stepsLength: number;
  advancedModeEnabled?: boolean;
  toggleAdvancedMode?: () => any;
  numCollapsedSteps?: number;
  onToggleAllStepsCollapse?: (value: boolean) => any;
  hideAdvancedMode: boolean;
};
type MenuItemType = {
  icon: string;
  text: string;
  itemClass?: string;
  condition?: () => any;
  onClick: () => any;
};

export const ProcedureHeaderOptionsDropdown = ({
  hideAdvancedMode,
  onToggleAllStepsCollapse,
  toggleAdvancedMode,
  className,
  numCollapsedSteps,
  stepsLength,
  advancedModeEnabled = false,
}: Props) => {
  const getItems = () => {
    const items: Array<MenuItemType> = [
      {
        icon: `far fa-fw fa-${advancedModeEnabled ? 'check-' : ''}square`,
        text: gt('Advanced mode'),
        condition: () => showAdvancedMode(),
        onClick: () => toggleAdvancedMode && toggleAdvancedMode(),
      },
    ];

    if (onToggleAllStepsCollapse != undefined) {
      const numCollapsed: number =
        numCollapsedSteps == undefined ? 0 : numCollapsedSteps;
      items.push(
        {
          icon: 'fa fa-fw fa-chevron-down',
          text: gt('Expand all steps'),
          condition: () => showStepsControl() && numCollapsed,
          onClick: () => onToggleAllStepsCollapse(false),
        },
        {
          icon: 'fa fa-fw fa-chevron-up',
          text: gt('Collapse all steps'),
          condition: () => showStepsControl() && numCollapsed < stepsLength,
          onClick: () => onToggleAllStepsCollapse(true),
        }
      );
    }

    return items;
  };

  const showAdvancedMode = () => {
    return !hideAdvancedMode && toggleAdvancedMode;
  };

  const showStepsControl = () => {
    return onToggleAllStepsCollapse != null;
  };

  return (
    <span className={`menu-options ${className || ''}`}>
      <UncontrolledDropdown tag={'span'}>
        <DropdownToggle color="link" className="btn-sm px-3">
          <i className="fa fa-ellipsis-v" />
        </DropdownToggle>
        <DropdownMenu right>
          {getItems().map((item, index) =>
            !item.condition || item.condition() ? (
              <DropdownItem
                key={index}
                onClick={item.onClick}
                className={item.itemClass || ''}
              >
                <i className={item.icon} /> {item.text}
              </DropdownItem>
            ) : null
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    </span>
  );
};
